<template>
	<main-layout>
		<!-- <button v-on:click="Bungie">Sign on to Bungie</button> -->
		<button v-on:click="Drive">Sign on to Drive</button>
	</main-layout>
</template>

<style>

</style>

<script>
	import {
		CLIENT_ID
	} from '../shared/private'
	import drive from '../shared/drive'
	import MainLayout from '../layouts/Main.vue'

	let url = window.location.href.split('?');
	if (url.length > 1) {
		let searchString = new URLSearchParams(url[1]);
		if (searchString.get("code")) {
			let time = new Date().getTime();
			localStorage.setItem('authorization', JSON.stringify({
				code: searchString.get("code"),
				expiryDate: time + 5 * 60 * 1000
			}));
			if (localStorage.getItem('tabbed')) {
				window.close();
			}

			window.location.href = window.location.href.split('?')[0];

			// Prevent the script from continuing since we are redirecting the page
		}
	}

	export default {
		name: "Auth",
		components: {
			'main-layout': MainLayout
		},
		created() {
			let self = this;
			drive.postAuth(function () {
				console.log("Hello")
				self.$router.push({
					path: '/'
				});
			})
		},
		methods: {
			Bungie: function () {
				window.open(`https://www.bungie.net/en/OAuth/Authorize?client_id=${CLIENT_ID}&response_type=code`);
				localStorage.setItem('tabbed', true);
				localStorage.removeItem('authorization');
				window.addEventListener("storage", function (event) {
					let authorization = localStorage.getItem('authorization');
					if (localStorage.getItem('tabbed') && authorization) {
						authorization = JSON.parse(authorization);

						console.log('Authorization', authorization);

						localStorage.removeItem('tabbed');
						bungie.refreshAccessToken({
							authCode: authorization.code
						}).then(resolve);
					}
				});
			},
			Drive: function () {

				drive.auth.immediate = false;
				gapi.auth.authorize(drive.auth, drive.refresh);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Auth.vue?7a00c682